export { default } from './CircleOutline'
